'use client';

import { useEffect, Suspense } from 'react';
import { useSearchParams } from 'next/navigation';
import AgahSplashLogo from '@/icons/iconsComponent/AgahSplashLogo';
import LogoFadeSplash from '@/icons/iconsComponent/LogoFadeSplash';
import { LoadingSplash } from '@/components/shared/LoadingSplash';
import { handleSignIn } from '@shared/lib/handleSignIn';

const SignInPage = () => {
  return (
    <div className='relative h-screen max-w-full bg-blue-1-active border-none'>
      <Suspense fallback={<LoadingSplash />}>
        <SignInRedirect />
      </Suspense>
    </div>
  );
};

const SignInRedirect = () => {
  const searchParams = useSearchParams();
  const callbackUrl = searchParams.get('callbackUrl') || '/';

  useEffect(() => {
    handleSignIn(true, callbackUrl);
  }, [callbackUrl]);

  return (
    <>
      <div className='absolute top-0 left-0'>
        <LogoFadeSplash />
      </div>
      <div className='absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[70%] md:-translate-y-[50%]'>
        <AgahSplashLogo className='scale-110' />
      </div>
    </>
  );
};

export default SignInPage;
